<template>
    <div class="header">
        <div class="header__top">
            <v-container class="d-flex justify-space-between align-center" style="padding: 0">
                <logo :width="104" :height="24"/>

                <div class="d-flex align-center">
                    <svg-icon name="user"/>
                    <div class="header__top-user" >
                        {{title}}
                    </div>
                    <div class="header__top-logout" @click="logoutHandler">
                        <svg-icon name="exit" />
                    </div>
                </div>
            </v-container>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            async logoutHandler() {
                await this.$store.dispatch('STUDIO_MAKE_LOGOUT')
                this.$router.push('/studios/sign-in/')
            },
        },
        computed: {
            getStudio() {
              return this.$store.getters.getStudio
            },
            title() {
                return this.getStudio.title
            }
        }
    }
</script>
